var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"decodeWrap valueTd"},[_c('span',{staticClass:"valueTd__svg icon_dollars"},[_vm._v("$")]),_c('span',[_vm._v(_vm._s(_vm.decodedValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }